document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-maki-customizer]').forEach(initMakiCustomizer);
});

function initMakiCustomizer(root) {
  const state = {
    top: null,    // { variantId, title, image }
    bottom: null,
  };

  const previewTop = root.querySelector('[data-preview="top"]');
  const previewBottom = root.querySelector('[data-preview="bottom"]');
  const labelTop = root.querySelector('[data-selected-label="top"]');
  const labelBottom = root.querySelector('[data-selected-label="bottom"]');
  const swatchTop = root.querySelector('[data-selected-swatch="top"]');
  const swatchBottom = root.querySelector('[data-selected-swatch="bottom"]');
  const addToCartBtn = root.querySelector('[data-add-to-cart]');
  const resetBtn = root.querySelector('[data-reset]');
  const statusEl = root.querySelector('[data-cart-status]');

  const modal = root.querySelector('[data-modal]');
  const modalGrid = root.querySelector('[data-modal-grid]');
  const modalTitle = root.querySelector('[data-modal-title]');

  const yarnDataBySide = {
    top: safeParseJSON(root.querySelector('[data-yarn-data-top]')),
    bottom: safeParseJSON(root.querySelector('[data-yarn-data-bottom]')),
  };

  function safeParseJSON(el) {
    if (!el) return [];
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return [];
    }
  }

  function selectYarn(side, data) {
    state[side] = data;

    // 選択状態のハイライトを更新
    root.querySelectorAll(`[data-yarn-option][data-side="${side}"]`).forEach((btn) => {
      btn.classList.toggle('is-selected', btn.dataset.variantId === String(data.variantId));
    });

    // プレビュー更新
    const previewEl = side === 'top' ? previewTop : previewBottom;
    previewEl.style.backgroundImage = `url('${data.image}')`;

    // 選択中の毛糸表示を更新
    const labelEl = side === 'top' ? labelTop : labelBottom;
    const swatchEl = side === 'top' ? swatchTop : swatchBottom;
    labelEl.textContent = data.title;
    swatchEl.style.backgroundImage = `url('${data.image}')`;

    updateAddToCartState();
  }

  function updateAddToCartState() {
    addToCartBtn.disabled = !(state.top && state.bottom);
  }

  // サムネイルクリック（グリッド表示分）
  root.querySelectorAll('[data-yarn-option]').forEach((btn) => {
    btn.addEventListener('click', () => {
      selectYarn(btn.dataset.side, {
        variantId: btn.dataset.variantId,
        title: btn.dataset.productTitle,
        image: btn.dataset.imageUrl,
      });
    });
  });

  // 「その他」→ モーダルを開く
  root.querySelectorAll('[data-open-modal]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const side = btn.dataset.openModal;
      const items = yarnDataBySide[side] || [];

      modalTitle.textContent = side === 'top' ? '上側の毛糸を選ぶ' : '下側の毛糸を選ぶ';
      modalGrid.innerHTML = '';

      items.forEach((item) => {
        const el = document.createElement('button');
        el.type = 'button';
        el.className = 'maki-yarn-thumb';
        el.innerHTML = `
          <span class="maki-yarn-thumb__img" style="background-image:url('${item.image}');"></span>
          <span class="maki-yarn-thumb__label">${item.title}</span>
        `;
        el.addEventListener('click', () => {
          selectYarn(side, item);
          closeModal();
        });
        modalGrid.appendChild(el);
      });

      openModal();
    });
  });

  function openModal() {
    modal.hidden = false;
  }
  function closeModal() {
    modal.hidden = true;
  }
  root.querySelectorAll('[data-modal-close]').forEach((el) => {
    el.addEventListener('click', closeModal);
  });

  // リセット
  resetBtn.addEventListener('click', () => {
    state.top = null;
    state.bottom = null;
    previewTop.style.backgroundImage = '';
    previewBottom.style.backgroundImage = '';
    labelTop.textContent = '未選択';
    labelBottom.textContent = '未選択';
    swatchTop.style.backgroundImage = '';
    swatchBottom.style.backgroundImage = '';
    root.querySelectorAll('[data-yarn-option]').forEach((btn) => btn.classList.remove('is-selected'));
    statusEl.textContent = '';
    updateAddToCartState();
  });

  // カートに追加（上側・下側を別々に追加）
  addToCartBtn.addEventListener('click', async () => {
    if (!state.top || !state.bottom) return;

    addToCartBtn.disabled = true;
    statusEl.textContent = 'カートに追加しています…';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [
            { id: Number(state.top.variantId), quantity: 1 },
            { id: Number(state.bottom.variantId), quantity: 1 },
          ],
        }),
      });

      if (!response.ok) {
        const err = await response.json();
        throw new Error(err.message || 'カートへの追加に失敗しました');
      }

      statusEl.textContent = 'カートに追加しました！';
    } catch (e) {
      statusEl.textContent = 'エラー：' + e.message;
    } finally {
      updateAddToCartState();
    }
  });
}
